module.exports = __webpack_public_path__ + "img/grand.1da90e14.png";